/**
 * A meeting's *With* picker, asked the way *Attached to* asks (Aaron, Oct 23,
 * note 4) — New request's engine, `GET /activity/find`.
 *
 * The one search that filled *With* and *Where* together is *Attached to*
 * now (Aaron, Oct 24, note 1.1: "rename the with and where search bar to
 * Attached To and remove the attached to at the bottom" — `attach.tsx`);
 * what is left here is *With*'s own box, which still finds a person by any
 * word, number or street of theirs.
 */
import { meetingFind } from '../api.js'
import type { ContactHit } from './contact-field.js'

/**
 * *With*'s own picker: contacts by name, number, email, company or street. A
 * contact of one place comes back on that place's row (New request's rule,
 * Board 3 A), so the places' people are read too.
 */
export function meetingContacts(q: string): Promise<ContactHit[]> {
  return meetingFind(q, 8).then((found) => {
    const hits: ContactHit[] = found.contacts.items.map((person) => ({
      id: person.id,
      label: `${person.firstName} ${person.lastName}`,
      sub: [person.phone, person.email, person.town].filter(Boolean).join(' · '),
    }))
    for (const place of found.properties.items) {
      for (const person of place.contacts) {
        if (hits.some((hit) => hit.id === person.id)) continue
        hits.push({ id: person.id, label: `${person.firstName} ${person.lastName}`,
          sub: [person.phone, person.email, place.name].filter(Boolean).join(' · ') })
      }
    }
    return hits
  })
}
